// Replace with your Firebase config
export const firebaseConfig = {
    apiKey: "AIzaSyBdd2Wlkkr0ayKjwB0nuc84eGjVFhP1xYY",
    authDomain: "zenmind-36458.firebaseapp.com",
    projectId: "zenmind-36458",
    storageBucket: "zenmind-36458.appspot.com",
    messagingSenderId: "900354988285",
    appId: "1:900354988285:web:a8da8752c83fd989454694"
};
